<script lang="ts" setup>
import { computed, inject } from 'vue'
import { VCol } from 'vuetify/components/VGrid'

import { getColParams, layoutKey } from './utils'
import KamaCol from '../KamaGrid/KamaCol.vue'
import LayoutGridItem from '../LayoutGrid/LayoutGridItem.vue'

import type { Layout } from '@/models/layout/layout.class'
import type { GridAlignment } from '@/types/serverGrid.type'

const props = defineProps<{
  area?: string | undefined
  horizontalAlign?: GridAlignment | undefined
  verticalAlign?: GridAlignment | undefined
  maxWidth?: string | undefined
  layout?: Layout | null
  classes?: string | undefined
}>()

const context = inject(layoutKey)
if (!context) throw new Error('LayoutItem должен находиться внутри LayoutContainer')

const columnProps = computed(() => {
  const params = context.value.ignoreLayout ? { cols: 12 } : getColParams(props.layout)
  const fillWidth = !context.value.ignoreLayout && props.layout?.useRow

  return context.value.variant === 'vuetify'
    ? { ...params, class: props.classes, fillWidth }
    : { params, classes: props.classes, fillWidth }
})
</script>

<template>
  <LayoutGridItem
    v-if="context.useGrid"
    :area="area"
    :horizontal-align="horizontalAlign"
    :vertical-align="verticalAlign"
    :max-width="maxWidth"
    :classes="classes"
  >
    <slot />
  </LayoutGridItem>
  <Component
    :is="context.variant === 'vuetify' ? VCol : KamaCol"
    v-else
    v-bind="columnProps"
  >
    <slot />
  </Component>
</template>
